import axios from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL
const PROJECT_URL = `${API_URL}/api/projetos`


const editProjectTeams = (projectId: number, data: {}): Promise<number> => {
  return axios
    .post(`${PROJECT_URL}/${projectId}/edit-teams`, data)
    .then((response) => response.data.data)
}

export {editProjectTeams}
